import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const RopstenAddresses = {
    TOKEN_RING: "0xb52FBE2B925ab79a821b261C82c5Ba0814AAA5e0",
    TOKEN_KTON: "0x1994100c58753793D52c6f457f189aa3ce9cEe94",
    TOKEN_WETH: "0xc778417E063141139Fce010982780140Aa0cD5Ab",
    ELEMENT_GOLD: "0xB6A07A36FA73758Ce9D58a2C6a8Da74CECCa438d",
    ELEMENT_WOOD: "0xda4d84c604977220D58ade0CF0D915b1a4099E35",
    ELEMENT_WATER: "0x40766Ce658Ae73E29242A3EDd75cF83F84c7120e",
    ELEMENT_FIRE: "0xC5C0f115C05dd10625A5d4d0fAf284100AD56E68",
    ELEMENT_SOIL: "0x5102d99fa797a12f611744cDAE69FF7A5F34b38D",
    GOLD_RUSH_RAFFLE: "0x5e6E812d9A7D35C344C7725835D85c8F977157B7",
    PVETEAM_PROXY: "",
    MATERIAL_PROXY: "",
    MATERIALTAKEBACK_PROXY: "",
    CRAFTBASE_PROXY: "",
    LAND_CLOCK_AUCTION: "0x9a6144237be8B5a6dc793E8848B6AeFc99bd2256",
    APOSTLE_CLOCK_AUCTION: "0xE862c7551b4361ee7DA08806affdB09850E8A284",
    SIRING_CLOCK_AUCTION: "0xfBe870C1084E6e5AE51b89765F70f1673bb9F6Ab",
    APOSTLE_BASE: "0x2E1dd56F118505a9D420Bf50D3bbAd80B3Aa2Ef3",
    LAND_RESOURCE: "0xD22065369994568096FB841e024462F4d7F5f2f9",
    TOKEN_USE: "0xfD9512e7c8d5D481661032768bBBdEA683D78865",
    OBJECTOWNERSHIP: "0x5eA9ea8E80230E514b5e023e8d956550a22D02c6",
    SETTINGSREGISTRY: "0x6982702995b053A21389219c1BFc0b188eB5a372",
    POINTS_REWARD_POOL: "0xc7eFAaa1b57EB6d5A1855dAf1a37f27cBEa5b5A5",
    TOKEN_USER_POINTS: "0x42a1D26d764a4ec858aB9e955B70e55FE409C749",
    FURNACE_TREASURE: "0xF72361096f11d7E4e45046d7a83726b1A9107D5E",
    FURNACE_ITEM_BASE: "0x1e257d7AE1Cf0da031480C5fE75478eB2d638540",
    FURNACE_TAKEBACK: "0xA10D0C6e04845A5e998d1936249A30563c553417",
    UNISWAP_EXCHANGE: "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
    STAKINGREWARDSFACTORY: "0x4CF6960c8700654b0379741D77B9d53fc59641CF",
    GOLDRAFFLEPOOL_PROXY: "",
    WOODRAFFLEPOOL_PROXY: "",
    WATERRAFFLEPOOL_PROXY: "",
    FIRERAFFLEPOOL_PROXY: "",
    SOILRAFFLEPOOL_PROXY: "",
};
export const RopstenTokens = {
    RING: new Token(ChainId.ROPSTEN, RopstenAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.ROPSTEN, RopstenAddresses.TOKEN_KTON, 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.ROPSTEN, RopstenAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.ROPSTEN, RopstenAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.ROPSTEN, RopstenAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.ROPSTEN, RopstenAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.ROPSTEN, RopstenAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.ROPSTEN],
};
